import { ProcessCellForExportParams } from 'ag-grid-community';
import { get } from 'lodash';

export class CyclicalCallFaultCellHelpers {
  static processValue(params: ProcessCellForExportParams): string {
    const { node } = params;
    return get(node, 'data.cyclicalCallFault.datetime');
  }
}
